import { BDropdown } from "bootstrap-vue";
import { forwardSlots } from "../createEgBootstrapProxy";

/**
 * Bootstrap-vue bridge — replace this file with your own EgBDropdown when migrating.
 * Keep hide() / show() if you use ref="dropdown" (e.g. dropdownHideOnLeaveMixin).
 */
export const EgBDropdown = {
  name: "EgBDropdown",
  inheritAttrs: false,
  computed: {
    visible() {
      return this.$refs._egBs ? this.$refs._egBs.visible : false;
    },
  },
  methods: {
    hide(...args) {
      return this.$refs._egBs?.hide?.(...args);
    },
    show(...args) {
      return this.$refs._egBs?.show?.(...args);
    },
  },
  render(h) {
    return h(
      BDropdown,
      {
        ref: "_egBs",
        attrs: { ...this.$attrs },
        on: this.$listeners,
        scopedSlots: this.$scopedSlots,
      },
      forwardSlots(this.$slots)
    );
  },
};
